import { Box, Heading, Stack } from "@sembark-travel/ui/base"
import { Helmet } from "react-helmet-async"
import { ActivityLogs } from "../../../../ActivityLogs"
import { useParams } from "../../../../router-utils"

function TransportServiceActivities() {
	const { serviceLocationId } = useParams(
		"/transport-services/:serviceLocationId"
	)
	return (
		<>
			<Helmet>
				<title>Transport Service Activities</title>
			</Helmet>
			<Box padding="6" bgColor="default" roundedBottom="md">
				<Stack gap="2">
					<Heading as="h5">Activities</Heading>
					<ActivityLogs
						subjectType="transport_service_locations"
						subjectId={Number(serviceLocationId)}
						hideTrackingInfo
					/>
				</Stack>
			</Box>
		</>
	)
}

export default TransportServiceActivities
